<template>
  <div class="player-loading">
    <div class="item"></div>
    <div class="item"></div>
    <div class="item"></div>
  </div>
</template>

<script>
    export default {
        name: "PlayerLoading"
    }
</script>

<style lang="scss" scoped>
.player-loading {
  position: absolute;
  left: 40px;
  right: 0;
  bottom: 0;
  height: 38px;
  text-align: center;
  z-index: 9;
  width: 50px;
  margin: auto;
  display: none;
}
.player-loading > .item{
  width: 5px;
  height: 5px;
  border-radius: 10px;
  margin: 2px;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;
}
.player-loading > .item:nth-child(1){
  -webkit-animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.player-loading > .item:nth-child(2){
  -webkit-animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.player-loading > .item:nth-child(3){
  -webkit-animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
@keyframes scale {
  30% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>